import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PoLetterType } from '@app/shared/utils';
import { catchError } from 'rxjs/operators';
import { ApiService } from './../api.service';
import { CoreFacade } from '@app/store/core/core.facade';
import { translateKey } from '@app/shared/utils/static-helpers/translate';
import { RCAlertType } from '@rc/ui';
import { Observable, of } from 'rxjs';
import { PoLetterBody } from '@app/letters/interfaces/po-letter-body';

import version from '@package.json';

@Injectable({ providedIn: 'root' })
export class POLetterService extends ApiService {
  constructor(
    private http: HttpClient,
    private coreFacade: CoreFacade,
  ) {
    super();
  }

  getPOLetterPdf(
    templateName: PoLetterType,
    data: PoLetterBody,
    clinicId: string,
    preview = false,
    isEBoutiqueLinksEnabled = false,
  ): Observable<{ data: string; fileUrl?: string; cacheKey?: string }> {
    const templateData = {
      ...data,
      version: version.version,
      pageSizes: {
        width: '595px',
        height: '842px',
      },
      ...this.getEBoutiqueQRConfig(clinicId, isEBoutiqueLinksEnabled),
    };
    const url = preview ? this.pathUrl.poLetterPreview(templateName) : this.pathUrl.poLetter(templateName);
    return this.http.post<{ data: string; fileUrl?: string; cacheKey?: string }>(url, templateData).pipe(
      catchError(() => {
        this.coreFacade.setAlert({
          message: translateKey('error_general_text'),
          alertType: RCAlertType.ERROR,
          dataQa: 'vs-po-letter-preview-alert',
        });
        return of(null);
      }),
    );
  }

  private getEBoutiqueQRConfig(clinicId, include) {
    return (
      include && {
        config: {
          eBoutiqueLink: {
            clinicId,
            path: 'pages[0].nutriReco.nutriRecoInfo.purchaseLinkButton',
          },
          eBoutiqueLinkQR: {
            clinicId,
            width: 70,
            path: 'pages[0].nutriReco.nutriRecoInfo.purchaseQrCode',
          },
        },
      }
    );
  }
}
